module.exports = __webpack_public_path__ + "static/media/White_with_Name.42e9ac1a.png";